import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { useAdminContext } from '../../../contexts/AdminContext';

const BookingModal = () => {
  const {
    handleCreateBooking,
    newBooking,
    setNewBooking,
    setShowAddBookingModal,
    showAddBookingModal,
  } = useAdminContext();

  return (
    <>
    {/* Add Workshop Booking Modal */}
    <Dialog open={showAddBookingModal} onOpenChange={setShowAddBookingModal}>
      <DialogContent className="bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-slate-900 dark:text-white">Add Workshop Booking</DialogTitle>
          <DialogDescription className="text-slate-500 dark:text-slate-500 dark:text-slate-400">
            Manually add a workshop booking request.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4 max-h-[60vh] overflow-y-auto pr-2">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Contact Name *</label>
              <Input
                value={newBooking.contact_name}
                onChange={(e) => setNewBooking(prev => ({ ...prev, contact_name: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="John Doe"
              />
            </div>
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Email *</label>
              <Input
                type="email"
                value={newBooking.email}
                onChange={(e) => setNewBooking(prev => ({ ...prev, email: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="john@company.com"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Phone</label>
              <Input
                value={newBooking.phone}
                onChange={(e) => setNewBooking(prev => ({ ...prev, phone: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="+32 ..."
              />
            </div>
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Company</label>
              <Input
                value={newBooking.company}
                onChange={(e) => setNewBooking(prev => ({ ...prev, company: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="Company Name"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Industry</label>
              <Input
                value={newBooking.industry}
                onChange={(e) => setNewBooking(prev => ({ ...prev, industry: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="Technology"
              />
            </div>
            <div>
              <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Team Size</label>
              <Input
                type="number"
                value={newBooking.team_size}
                onChange={(e) => setNewBooking(prev => ({ ...prev, team_size: e.target.value }))}
                className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
                placeholder="50"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Preferred Date</label>
            <Input
              type="date"
              value={newBooking.preferred_date}
              onChange={(e) => setNewBooking(prev => ({ ...prev, preferred_date: e.target.value }))}
              className="bg-slate-100 dark:bg-slate-700 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white"
            />
          </div>
          <div>
            <label className="block text-sm text-slate-500 dark:text-slate-500 dark:text-slate-400 mb-1">Interests / Notes</label>
            <textarea
              value={newBooking.interests}
              onChange={(e) => setNewBooking(prev => ({ ...prev, interests: e.target.value }))}
              className="w-full bg-slate-100 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white rounded-md p-2 min-h-[80px]"
              placeholder="What are they interested in..."
            />
          </div>
          <div className="flex justify-end gap-2 mt-6">
            <Button variant="outline" onClick={() => setShowAddBookingModal(false)} className="border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300">
              Cancel
            </Button>
            <Button 
              onClick={handleCreateBooking}
              disabled={!newBooking.contact_name || !newBooking.email}
              className="bg-green-500 hover:bg-green-600"
            >
              Add Booking
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
    </>
  );
};

export default BookingModal;
